export const SESSION_EXPIRED_EVENT = 'auth:session-expired';

export interface SessionExpiredDetail {
  reason: string;
}

/**
 * Emits a session expired event that can be listened to by the UI layer.
 * This decouples the API layer from Redux to avoid circular dependencies.
 */
export const emitSessionExpired = (reason: string): void => {
  window.dispatchEvent(
    new CustomEvent<SessionExpiredDetail>(SESSION_EXPIRED_EVENT, {
      detail: { reason },
    })
  );
};
